import React, { createContext, useContext, useState } from 'react';
import { useFieldArrayController } from '../hooks';
import { useEvent } from '../../../hooks/useEvent';

const StateContext = createContext();
const MethodsContext = createContext();

export const useFieldArrayState = () => useContext(StateContext);
export const useFieldArrayMethods = () => useContext(MethodsContext);

export const FieldArrayProvider = ({ children, ...props }) => {
  const {
    append: _append,
    remove: _remove,
    fields,
    ..._methods
  } = useFieldArrayController(props);

  const append = useEvent((props, cb) => {
    _append(props);

    if (typeof cb === 'function') {
      cb({ fieldCount: fields.length + 1 });
    }
  });

  const remove = useEvent((index, cb) => {
    _remove(index);

    if (typeof cb === 'function') {
      cb({ fieldCount: fields.length - 1 });
    }
  });

  const getFields = useEvent(() => fields);

  const [methods] = useState(
    () => ({
      ..._methods,
      append,
      remove,
      getFields,
    }),
    [append, remove, getFields, _methods]
  );

  return (
    <StateContext.Provider value={fields}>
      <MethodsContext.Provider value={methods}>
        {children}
      </MethodsContext.Provider>
    </StateContext.Provider>
  );
};
